<mapp-action-modal
    [iconPath]="'/assets/icons/warning-blue.svg'"
    [title]="title"
    [description]="description"
    [primaryButton]="primaryButtonObject"
    [hideCloseButton]="true"
></mapp-action-modal>
